// Florida State University's undergraduate majors (#2652). Read on
// 2026-10-01 from the 2026-2027 FSU General Bulletin's Academic Degree and
// Certificate Programs page (bulletin.fsu.edu/academics/degrees-certs),
// which lists each college's regular degree programs and marks the level
// offered (B for bachelor's, M, S, D, P): every program marked B is kept,
// combined bachelor's/master's pathways, certificates and graduate-only
// programs left out. The page gives levels, not degree names, so `degree`
// is null throughout. Two notes: the Bulletin says its list "was accurate at
// the time of publication" and points to Institutional Research's Degree
// Program Inventory for the most current list; and the Bulletin writes the
// engineering college with a dash glyph ("FAMU-FSU College of Engineering"
// here, as its own website link spells it). Majors that FSU's Academic
// Program Guide splits into tracks appear once, under the Bulletin's name.
// The KB's majors list was the starting point; the school's list wins.
const majors = {
    "slug": "florida-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in FSU's official 2026-2027 General Bulletin, grouped by the college that offers it. The Bulletin lists programs by degree level, not by degree name. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Applied Studies",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Financial Planning",
                    "degree": null
                },
                {
                    "name": "Professional Communication",
                    "degree": null
                },
                {
                    "name": "Public Safety and Security",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemical Science",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Computational Biology",
                    "degree": null
                },
                {
                    "name": "Computational Science",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Cyber Criminology - Computer Science",
                    "degree": null
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Greek",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Humanities",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Latin",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Meteorology",
                    "degree": null
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Modern Languages, Literatures, and Cultures",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physical Science",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Business",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": null
                },
                {
                    "name": "Business Administration",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Management Information Systems",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                },
                {
                    "name": "Real Estate",
                    "degree": null
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Communication and Information",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Communication and Digital Media Studies",
                    "degree": null
                },
                {
                    "name": "Communication Science and Disorders",
                    "degree": null
                },
                {
                    "name": "Information Technology",
                    "degree": null
                },
                {
                    "name": "Professional Communication",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Criminology and Criminal Justice",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Criminology",
                    "degree": null
                },
                {
                    "name": "Cyber Criminology",
                    "degree": null
                }
            ]
        },
        {
            "name": "Anne Spencer Daves College of Education, Health, and Human Sciences (Anne's College)",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Athletic Training",
                    "degree": null
                },
                {
                    "name": "Blindness and Low Vision",
                    "degree": null
                },
                {
                    "name": "Dietetics",
                    "degree": null
                },
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "English Education",
                    "degree": null
                },
                {
                    "name": "Exercise Physiology",
                    "degree": null
                },
                {
                    "name": "Food and Nutrition",
                    "degree": null
                },
                {
                    "name": "Family Science",
                    "degree": null
                },
                {
                    "name": "Social Science Education",
                    "degree": null
                },
                {
                    "name": "Special Education",
                    "degree": null
                },
                {
                    "name": "Sport Management",
                    "degree": null
                },
                {
                    "name": "STEM Teaching",
                    "degree": null
                }
            ]
        },
        {
            "name": "FAMU-FSU College of Engineering",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "Jim Moran College of Entrepreneurship",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Entrepreneurship",
                    "degree": null
                },
                {
                    "name": "Retail Entrepreneurship",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "History and Criticism of Art",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                }
            ]
        },
        {
            "name": "Dedman College of Hospitality",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Hospitality Management",
                    "degree": null
                },
                {
                    "name": "Recreation and Tourism Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Medicine",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Motion Picture Arts",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Motion Picture Arts",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Music",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Music - Liberal Arts",
                    "degree": null
                },
                {
                    "name": "Music Education",
                    "degree": null
                },
                {
                    "name": "Music Performance",
                    "degree": null
                },
                {
                    "name": "Music Theory and Composition",
                    "degree": null
                },
                {
                    "name": "Music Therapy",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Social Sciences and Public Policy",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "African-American Studies",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Environment and Society",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Social Science",
                    "degree": null
                },
                {
                    "name": "International Affairs",
                    "degree": null
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Public Health",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "FSU 2026-2027 General Bulletin, Academic Degree and Certificate Programs",
                "url": "https://bulletin.fsu.edu/academics/degrees-certs"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
